import { render, staticRenderFns } from "./account-view.vue?vue&type=template&id=c1ca031a&"
import script from "./account-view.vue?vue&type=script&lang=ts&"
export * from "./account-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports